import React from 'react';
import { Clickable } from '@moda/om';
import { SetupApplePaySession } from './SetupApplePaySession';
import { useIsApplePaySupported } from './useIsApplePaySupported';
import './ApplePayButton.scss';

export const APPLE_PAY_BUTTON_ID = 'apple-pay-button';

type Props = {
  size?: 'small' | 'large';
  onClick?: () => void;
  session?: ApplePaySession | null;
};

export const ApplePayButton: React.FC<Props> = ({ size = 'large', onClick, session }) => {
  const isApplePaySupported = useIsApplePaySupported();

  if (!isApplePaySupported) return null;

  return (
    <Clickable
      className={`ApplePayButton ApplePayButton--${size}`}
      onClick={session ? undefined : onClick}
    >
      {session && <SetupApplePaySession session={session} />}

      <div id={APPLE_PAY_BUTTON_ID} />
    </Clickable>
  );
};
